import { NgModule } from '@angular/core';
import { ClientPreQualificationsComponent } from './client-pre-qualifications.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ClientPreQualificationsEditComponent } from './client-pre-qualifications-edit/client-pre-qualifications-edit.component';
import { ClientPreQualificationsViewComponent } from './client-pre-qualifications-view/client-pre-qualifications-view.component';
import { ClientPreQualificationsRoutingModule } from './client-pre-qualifications-routing.module';
import { ClientPreQualificationsItemsModule } from '../client-pre-qualifications-items/client-pre-qualifications-items.module';
import { ClipboardModule } from 'ngx-clipboard';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
    declarations: [
        ClientPreQualificationsComponent,
        ClientPreQualificationsEditComponent,
        ClientPreQualificationsViewComponent
    ],
    imports: [
        CommonModule,
        ClientPreQualificationsRoutingModule,
        MatButtonModule,
        FormsModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatIconModule,
        MatDialogModule,
        ClientPreQualificationsItemsModule,
        ClipboardModule,
        MatTooltipModule,
        DirectivesModule,
        PipesModule
    ]
})
export class ClientPreQualificationsModule {}
